export const ASSET_TYPES_CONFIG = [
  { value: 'auto', label: 'Auto detect', color: '#a78bfa' },
  { value: 'logo', label: 'Logo', color: '#667eea' },
  { value: 'banner', label: 'Banner', color: '#f093fb' },
  { value: 'product', label: 'Product', color: '#52c41a' },
  { value: 'person', label: 'Person', color: '#fa8c16' },
  { value: 'place', label: 'Place', color: '#1890ff' },
  { value: 'background', label: 'Background', color: '#722ed1' },
  { value: 'icon', label: 'Icon', color: '#eb2f96' },
  { value: 'screenshot', label: 'Screenshot', color: '#13c2c2' },
  { value: 'ad', label: 'Ad', color: '#ff4d4f' },
  { value: 'uniform', label: 'Uniform', color: '#fa541c' },
  { value: 'other', label: 'Other', color: '#8c8c8c' },
];

export const ASSET_TYPE_MAP = Object.fromEntries(
  ASSET_TYPES_CONFIG.map((t) => [t.value, t])
);

export const CAPTION_STATUS = {
  pending: { label: 'Pending', color: '#8c8c8c' },
  processing: { label: 'Generating…', color: '#fa8c16' },
  done: { label: 'Ready', color: '#52c41a' },
  failed: { label: 'Failed', color: '#f5576c' },
};

export const detectType = (filename) => {
  const n = (filename || '').toLowerCase();
  if (/logo/.test(n)) return 'logo';
  if (/banner|hero|cover|header/.test(n)) return 'banner';
  if (/product|prod/.test(n)) return 'product';
  if (/person|people|team|portrait|headshot/.test(n)) return 'person';
  if (/bg|background|backdrop|texture/.test(n)) return 'background';
  if (/icon|ico/.test(n)) return 'icon';
  if (/screen|screenshot/.test(n)) return 'screenshot';
  if (/ad|ads|campaign|advert/.test(n)) return 'ad';
  if (/uniform|outfit|apparel/.test(n)) return 'uniform';
  if (/place|location|store|venue|building/.test(n)) return 'place';
  return 'other';
};
